var map = {
	"./age-verification/age-verification.module": [
		"./src/app/pages/age-verification/age-verification.module.ts",
		"age-verification-age-verification-module"
	],
	"./another-page/another-page.module": [
		"./src/app/pages/turf/another-page/another-page.module.ts",
		"another-page-another-page-module"
	],
	"./bonus/bonus.module": [
		"./src/app/pages/bonus/bonus.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"bonus-bonus-module"
	],
	"./faq/faq.module": [
		"./src/app/pages/turf/faq/faq.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"faq-faq-module"
	],
	"./footer-page/footer-page.module": [
		"./src/app/pages/footer-page/footer-page.module.ts",
		"footer-page-footer-page-module"
	],
	"./gratuits/gratuits.module": [
		"./src/app/pages/turf/gratuits/gratuits.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"gratuits-gratuits-module"
	],
	"./how-to-play/how-to-play.module": [
		"./src/app/pages/turf/how-to-play/how-to-play.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"how-to-play-how-to-play-module"
	],
	"./lexique/lexique.module": [
		"./src/app/pages/turf/lexique/lexique.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"lexique-lexique-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages-pages-module"
	],
	"./prediction-details/prediction-details.module": [
		"./src/app/pages/turf/prediction-details/prediction-details.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"prediction-details-prediction-details-module"
	],
	"./promotions/promotions.module": [
		"./src/app/pages/turf/promotions/promotions.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"promotions-promotions-module"
	],
	"./registration/registration.module": [
		"./src/app/pages/registration/registration.module.ts",
		"registration-registration-module"
	],
	"./turf-home/turf-home.module": [
		"./src/app/pages/turf/turf-home/turf-home.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"turf-home-turf-home-module"
	],
	"./turf-predictions/turf-predictions.module": [
		"./src/app/pages/turf/turf-predictions/turf-predictions.module.ts",
		"default~bonus-bonus-module~faq-faq-module~gratuits-gratuits-module~how-to-play-how-to-play-module~le~8434fff7",
		"common",
		"turf-predictions-turf-predictions-module"
	],
	"./turf/turf.module": [
		"./src/app/pages/turf/turf.module.ts",
		"common",
		"turf-turf-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;